import React from 'react';
import Container from '../ui/Container';
import SectionTitle from '../ui/SectionTitle';
import Button from '../ui/Button';

// Компонент кривых для паттерна (7 волн)
const BackgroundCurves: React.FC = () => (
  // Чтобы использовать переменные из globals.css в SVG, мы применяем стили через атрибут style
  <svg 
    className="absolute inset-0 w-full h-full pointer-events-none" 
    viewBox="0 0 1440 800" 
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="none"
  >
    <defs>
      {/* Кривая линия 1: Широкая, низкая волна */}
      <path id="curve1" d="M 0 200 C 400 500 800 100 1440 400" fill="none" style={{ stroke: 'var(--brand-primary)', strokeOpacity: 0.05, strokeWidth: 2 }} />
      
      {/* Кривая линия 2: Высокая частота, средний уровень */}
      <path id="curve2" d="M 0 600 C 200 400 400 700 600 500 S 1000 300 1440 550" fill="none" style={{ stroke: 'var(--brand-primary)', strokeOpacity: 0.10, strokeWidth: 1 }} />
      
      {/* Кривая линия 3: Пологий, очень низкий наклон */}
      <path id="curve3" d="M 0 750 C 700 700 1000 780 1440 700" fill="none" style={{ stroke: 'var(--brand-primary)', strokeOpacity: 0.03, strokeWidth: 3 }} />
      
      {/* Кривая линия 4: Диагональный подъем с низким пиком */}
      <path id="curve4" d="M 0 100 C 300 300 600 0 1440 250" fill="none" style={{ stroke: 'var(--brand-primary)', strokeOpacity: 0.12, strokeWidth: 1 }} />
      
      {/* Кривая линия 5: Центральный пик, симметричная волна */}
      <path id="curve5" d="M 0 450 C 300 650 720 250 1440 450" fill="none" style={{ stroke: 'var(--brand-primary)', strokeOpacity: 0.08, strokeWidth: 2 }} />
      
      {/* Кривая линия 6: Волна у нижней границы, плотная */}
      <path id="curve6" d="M 0 700 C 250 650 500 750 750 680 S 1100 600 1440 720" fill="none" style={{ stroke: 'var(--brand-primary)', strokeOpacity: 0.06, strokeWidth: 1 }} />
      
      {/* Кривая линия 7: Самая высокая прозрачность, для "шума" */}
      <path id="curve7" d="M 0 350 C 350 300 700 400 1440 380" fill="none" style={{ stroke: 'var(--brand-primary)', strokeOpacity: 0.15, strokeWidth: 1 }} />
    </defs>
    
    {/* Использование 7 уникальных кривых */}
    <use href="#curve1" />
    <use href="#curve2" />
    <use href="#curve3" />
    <use href="#curve4" />
    <use href="#curve5" />
    <use href="#curve6" />
    <use href="#curve7" />
  </svg>
);

const VibeGallery: React.FC = () => {
  return (
    <section id="vibe" className="py-24 lg:py-36 2xl:py-48 bg-brand-secondary relative sticky top">
      {/* ФОНОВЫЙ ПАТТЕРН */}
      <BackgroundCurves />
      <div className="grid-system !gap-0">
        <div className="grid-text mb-16">
          <SectionTitle 
            title="Атмосфера студии" 
            subtitle="Мы создаем комьюнити, где каждый чувствует себя свободно. Танцуем, смеемся, снимаем крутые видео и участвуем в соревнованиях"
            variant='light' 
          />
        </div>

        <div className="grid-full">
          <div className="relative rounded-4xl md:rounded-5xl overflow-hidden">
            <img 
              src="/images/gallery/vibe.png" 
              className="w-full h-[400px] md:h-[600px] lg:h-[800px] object-cover" 
              alt="Атмосфера студии Fun Dance"
            />
          </div>
        </div>

        <div className="grid-text mt-8 md:mt-12 text-center">
          <Button 
            variant="secondary"
            className="w-full md:w-auto" 
            href="https://t.me/basra_break_dance"
          >
            Подписаться на Telegram
          </Button>
        </div>
      </div>
    </section>
  );
};

export default VibeGallery;